import React, { useEffect, useRef, useState } from 'react';

const Benefits: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredSide, setHoveredSide] = useState<'traditional' | 'wenergie' | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="h-[30rem] relative overflow-hidden  p-3"
    >
      <div className="flex h-full gap-3 transition-all duration-700">
        {/* Left Side - Traditional Energy */}
        <div
          className={`relative flex flex-col justify-center items-start p-12 lg:p-16 cursor-pointer group transition-all duration-700 rounded-l-xl ${hoveredSide === 'traditional' ? 'flex-[3]' :
              hoveredSide === 'wenergie' ? 'flex-[2]' : 'flex-1'
            }`}
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/assets/traditional-energy.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          onMouseEnter={() => setHoveredSide('traditional')}
          onMouseLeave={() => setHoveredSide(null)}
        >
          {/* Content */}
          <div className={`max-w-lg transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
            <h2 className={`text-4xl lg:text-5xl font-light text-white mb-6 transition-all duration-500 ${hoveredSide === 'traditional' ? 'transform scale-105' : ''
              }`}>
              Energy is stuck in the past
            </h2>

            <div className={`transition-all duration-500 overflow-hidden ${hoveredSide === 'traditional' ? 'max-h-96 opacity-100' : 'max-h-32 opacity-80'
              }`}>
              

              {hoveredSide === 'traditional' && (
                <p className="text-white/80 text-base leading-relaxed">
                  <ul className="text-white/90 text-lg leading-relaxed space-y-3 list-disc pl-5">
                    <li>Power from polluting coal and fossil fuels</li>
                    <li>No transparency</li>
                    <li>Inflexible, unfair pricing</li>
                  </ul>
                </p>
              )}
            </div>
          </div>


        </div>

        {/* Right Side - Wenergie */}
        <div
          className={`relative flex flex-col justify-center items-start p-12 lg:p-16 cursor-pointer group transition-all duration-700 rounded-r-xl ${hoveredSide === 'wenergie' ? 'flex-[3]' :
              hoveredSide === 'traditional' ? 'flex-[2]' : 'flex-1'
            }`}
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('/assets/solar-energy.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          onMouseEnter={() => setHoveredSide('wenergie')}
          onMouseLeave={() => setHoveredSide(null)}
        >
          {/* Content */}
          <div className={`max-w-lg transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
            <h2 className={`text-4xl lg:text-5xl font-bold text-white mb-6 transition-all duration-500 ${hoveredSide === 'wenergie' ? 'transform scale-105' : ''
              }`}>
              We're powering tomorrow
            </h2>

            <div className={`transition-all duration-500 overflow-hidden ${hoveredSide === 'wenergie' ? 'max-h-96 opacity-100' : 'max-h-32 opacity-80'
              }`}>
               

              {hoveredSide === 'wenergie' && (
                <p className="text-white/80 text-base leading-relaxed">
                  <ul className="text-white/90 text-lg leading-relaxed space-y-3 list-disc pl-5">
                    <li>Locally-sourced power from Solar Panels</li>
                    <li>Real-time visibility into your energy generation and consumption</li>
                    <li>Incentives and exciting rewards for clean energy use; better compensation for solar homes</li>
                  </ul>
                </p>
              )}
            </div>
          </div>


        </div>
      </div>



      {/* Mobile responsive stacked layout */}
      <style >{`
        @media (max-width: 768px) {
          .grid {
            grid-template-rows: 1fr 1fr;
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default Benefits;